import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as BookSvg } from './assets/book.svg';

const BookIcon = React.forwardRef((args, ref) => <SvgIcon component={BookSvg} ref={ref} {...args} />);

export default BookIcon;
